import { gql } from '@apollo/client';

export const GET_TENANTS = gql`
query getTenants($input:TenantInput ) {
  getTenants(input: $input) {
    tenantId
     orgAdminGroupId       
     orgUserGroupId 
     name
     type
     iamStatus
     users{
      fullName
    }
  }
}`;

export const GET_TENANT_BY_ID = gql`
query getTenantById($input:TenantByIdInput ) {
  getTenantById(input: $input) {
    tenantId
    name
    users{
      fullName
    }
    type
    iamAllowedDomains
    iamRestrictedDomains
    iamOnboardOrganizationAdmin
    iamStatus
    orgAdminGroupId       
    orgUserGroupId
  }
}`;

export const GET_MODULES = gql`
query getModules{
  getModules{
    moduleName
    moduleDisplayName
    moduleId
    createdAt
  }
}`;

export const GET_REGULATORS = gql`
query getRegulators{
  getRegulators{
    regulatorId
    name
    displayName
  }
}`;

export const GET_REGULATOR_SELECT = gql`
   query GetRegulatorSelect {
       selectValue @client
   }
`;

// This queries YOUR backend (localhost:3000), not IAM
// Your backend's getUser resolver joins User + Tenant + UserTenants from DB
export const GET_USER_INFO = gql`
   query getAppUser { getUser {      
    email       
    userId       
    firstName       
    lastName       
    fullName       
    initials       
    phone       
    iamRole       
    iamUserStatus      
    organizationIdList      
      iamTenant {         
      tenantId         
      name         
      type         
      createdAt        
       domainUrls         
       iamAllowedDomains         
       iamRestrictedDomains        
        iamOnboardOrganizationAdmin        
         iamStatus         
         orgAdminGroupId         
         orgUserGroupId       
         }      
       userTenants {         
       tenantId        
        name         
        type         
        createdAt         
        domainUrls         
        iamAllowedDomains        
         iamRestrictedDomains         
         iamOnboardOrganizationAdmin        
          iamStatus         
          orgAdminGroupId       
          }       
          userStatus       
          agreedLatestTerms       
          type       
          indexing      
           moduleIds     
           }   
           }
`;

export const GET_USERS = gql`
query getUsers($input: GetUsersInput){
  getUsers(input: $input){
    userId
    email
    firstName
    lastName
    fullName
    initials
    phone
    organizationIdList
    iamTenant {
      tenantId
      name
      type
      createdAt
      domainUrls
      iamAllowedDomains
      iamRestrictedDomains
      iamOnboardOrganizationAdmin
      iamStatus
      orgAdminGroupId         
      orgUserGroupId
    }
    userTenants {
      tenantId
      name
      type
      createdAt
      domainUrls
      iamAllowedDomains
      iamRestrictedDomains
      iamOnboardOrganizationAdmin
      iamStatus
      orgAdminGroupId
    }
    userStatus
    agreedLatestTerms
    type
    indexing
    iamUserStatus
    registrationStatus
  }
}`;

export const GET_USER_BY_ID = gql`
query getUserById($input: GetUserByIdInput){
  getUserById(input: $input){
    email
    userId
    firstName
    lastName
    fullName
    initials
    phone
    organizationIdList 
    iamTenant {
      tenantId
      name
      type
      createdAt
      domainUrls
      iamAllowedDomains
      iamRestrictedDomains
      iamOnboardOrganizationAdmin
      iamStatus
      orgAdminGroupId         
      orgUserGroupId
    }
    userTenants {
      tenantId
      name
      type
      createdAt
      domainUrls
      iamAllowedDomains
      iamRestrictedDomains
      iamOnboardOrganizationAdmin
      iamStatus
      orgAdminGroupId
    }
    userStatus
    iamRole
    iamUserStatus
    requestingUserEmail
    agreedLatestTerms
    type
    indexing
    moduleIds
  }
}`;

export const GET_USER_ROLES = gql`
query getUserRoles{
  getUserRoles{
    userRoleId
    name
  }
}`;

export const GET_TERMS_OF_AGREEMENTS = gql`
query getTermsOfAgreements{
  getTermsOfAgreements{
    termsId
    privacyPolicy
    terms
    html
  }
}`;

export const GET_USERS_FOR_PROFILE = gql`
query getUsers($input: GetUsersInput){
  getUsers(input: $input){
    userId
    fullName
  }
}`;

export const GET_USER_TENANT_ROLES = gql`
query getUserTenantRoles($input: GetUserTenantRolesInput){
  getUserTenantRoles(input: $input){
    userTenantRoleId
    tenantId
    userId
    userRoleId
    jobTitle
    department
    userRole {
      name
      userRoleId
    }
    tenant {
      name
      tenantId
    }
  }
}`;

export const GET_PENDING_INVIATION_COUNT = gql`
  query {
    getPendingIntakeInvitationsCount {
      count
    }
  }
`;

export const GET_INSTITUTION_LIST = gql`
query {
  getInstitutionList
}
`;

export const GET_REGISTRATION_INTAKE_LIST = gql`
query {
  getAllRegistrationIntake {
    id
    firstName
    lastName
    email
    phone
    countryCode
    institution
    invitationStatus
    module {
    moduleName
    }
    createdAt
    updatedAt
    accessEndDate
    status
  }
}
`;

export const GET_DEMO_SCATTER_DATA = gql`
  query getScatterData(
    $form: String!
    $rssid: String!
    $startQuarter: String!
    $endQuarter: String!
    $case: String!
  ) {
    DEMOscatterData(
      form: $form
      rssid: $rssid
      startQuarter: $startQuarter
      endQuarter: $endQuarter
      case: $case
    ) {
      data
      metaData
    }
  }
`;

export const GET_DEMO_TABLE_DATA = gql`
  query getTableData(
    $form: String!
    $rssid: String!
    $startQuarter: String!
    $endQuarter: String!
    $case: String!
    $mdrms: [String!]!
  ) {
    DEMOtableData(
      form: $form
      rssid: $rssid
      startQuarter: $startQuarter
      endQuarter: $endQuarter
      case: $case
      mdrms: $mdrms
    ) {
      data
    }
  }
`;

export const GET_DEMO_TRENDLINE_AND_HEATMAP_DATA = gql`
  query getTrendlineAndHeatmapData(
    $form: String!
    $mdrms: [String!]!
    $startQuarter: String!
    $endQuarter: String!
    $interval: Int!
    $case: String!
  ) {
    DEMOmdrmData(
      form: $form
      mdrms: $mdrms
      startQuarter: $startQuarter
      endQuarter: $endQuarter
      interval: $interval
      case: $case
    ) {
      periods
      scale {
        value
        color
      }
      results {
        data
        meta
      }
      metaData {
        MDRM
        Color
      }
    }
  }
`;

export const GET_DEMO_FORM_DETAILS = gql`
  query getFormDetails($form: String!) {
    DEMOgetFormDetails(form: $form) {
      forms
      rssids
      StartQuarter
      EndQuarter
      default {
        form
        rssid
        StartQuarter
        EndQuarter
      }
    }
  }
`;

export const GET_DEMO_BENCHMARK_ALL = gql`
  query GET_BENCHMARK_ALL(
    $form: String!
    $institutionA: String!
    $compareWith: [String!]!
    $quarter: String!
    $case: String!
    $mdrm: String!
  ) {
    DEMObenchmarkAll(
      form: $form
      institutionA: $institutionA
      compareWith: $compareWith
      quarter: $quarter
      case: $case
      mdrm: $mdrm
    )
  }
`;
export const GET_BENCHMARK_SCATTER_DATA = gql`
  query getScatterData(
    $form: String!
    $rssid: String!
    $startQuarter: String!
    $endQuarter: String!
    $case: String!
  ) {
    BENCHMARKscatterData(
      form: $form
      rssid: $rssid
      startQuarter: $startQuarter
      endQuarter: $endQuarter
      case: $case
    ) {
      data
      metaData
    }
  }
`;

export const GET_BENCHMARK_TABLE_DATA = gql`
  query getTableData(
    $form: String!
    $rssid: String!
    $startQuarter: String!
    $endQuarter: String!
    $case: String!
    $mdrms: [String!]!
  ) {
    BENCHMARKtableData(
      form: $form
      rssid: $rssid
      startQuarter: $startQuarter
      endQuarter: $endQuarter
      case: $case
      mdrms: $mdrms
    ) {
      data
    }
  }
`;

export const GET_BENCHMARK_TRENDLINE_AND_HEATMAP_DATA = gql`
  query getTrendlineAndHeatmapData(
    $form: String!
    $mdrms: [String!]!
    $startQuarter: String!
    $endQuarter: String!
    $interval: Int!
    $case: String!
  ) {
    BENCHMARKmdrmData(
      form: $form
      mdrms: $mdrms
      startQuarter: $startQuarter
      endQuarter: $endQuarter
      interval: $interval
      case: $case
    ) {
      periods
      scale {
        value
        color
      }
      results {
        data
        meta
      }
      metaData {
        MDRM
        Color
      }
    }
  }
`;

export const GET_BENCHMARK_FORM_DETAILS = gql`
  query getFormDetails($form: String!) {
    BENCHMARKgetFormDetails(form: $form) {
      forms
      rssids
      StartQuarter
      EndQuarter
      default {
        form
        rssid
        StartQuarter
        EndQuarter
      }
    }
  }
`;

export const GET_BENCHMARK_BENCHMARK_ALL = gql`
  query GET_BENCHMARK_ALL(
    $form: String!
    $institutionA: String!
    $compareWith: [String!]!
    $quarter: String!
    $case: String!
    $mdrm: String!
  ) {
    BENCHMARKbenchmarkAll(
      form: $form
      institutionA: $institutionA
      compareWith: $compareWith
      quarter: $quarter
      case: $case
      mdrm: $mdrm
    )
  }
`;


export const GET_BENCHMARK_HEATMAP_VARIATIONS = gql`
  query GET_BENCHMARK_HEATMAP_VARIATIONS(
    $form: String!
    $rssid: String!
    $mdrms: [String!]!
    $startQuarter: String!
    $endQuarter: String!
  ) {
    BENCHMARKHeatmapVariations(
      form: $form
      rssid: $rssid
      mdrms: $mdrms
      startQuarter: $startQuarter
      endQuarter: $endQuarter
    ) {
      periods
      scale {
        value
        color
      }
      rows {
        mdrm
        scheduleColor
        schedule
        lineItemCode
        itemName
        cells {
          quarter
          value
          logValue
          normalized
          color
        }
      }
    }
  }
`;

export const GET_DEMO_HEATMAP_VARIATIONS = gql`
  query GET_DEMO_HEATMAP_VARIATIONS(
    $form: String!
    $rssid: String!
    $mdrms: [String!]!
    $startQuarter: String!
    $endQuarter: String!
  ) {
    DEMOHeatmapVariations(
      form: $form
      rssid: $rssid
      mdrms: $mdrms
      startQuarter: $startQuarter
      endQuarter: $endQuarter
    ) {
      periods
      scale {
        value
        color
      }
      rows {
        mdrm
        scheduleColor
        schedule
        lineItemCode
        itemName
        cells {
          quarter
          value
          logValue
          normalized
          color
        }
      }
    }
  }
`;
